import { render, staticRenderFns } from "./VehicleRequestList.vue?vue&type=template&id=3c2fa57e&"
import script from "./VehicleRequestList.vue?vue&type=script&lang=js&"
export * from "./VehicleRequestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports